import {
  VehicleVm,
  getVehicleApi,
  VehicleCreateVm,
  postVehicleApi,
  putVehicleApi,
  VehicleUpdateVm
} from "@/services/vehicles";
import actions from "./actions";
import { ApiCallParams } from "@/services/baseService";
import accountActions from "@/store/accounts/actions";

export default {
  actions: {
    async [actions.FETCH_VEHICLE](ctx?: any) {
      const vehicle: VehicleVm | undefined = await getVehicleApi();
      if (vehicle !== undefined) {
        ctx.commit("updateVehicleDataMutation", vehicle);
      }
    },

    async [actions.CREATE_VEHICLE](
      ctx?: any,
      params?: ApiCallParams<VehicleCreateVm>
    ) {
      if (params !== undefined) {
        const result = await postVehicleApi(params);

        if (result) {
          await ctx.dispatch(actions.FETCH_VEHICLE);
          await ctx.dispatch(accountActions.GET_MY_ACCOUNT_DETAILS);
        }

        ctx.commit("updateIsUpdateMyVehicleButtonLoadingMutation", false);
      }
    },

    async [actions.UPDATE_VEHICLE](
      ctx?: any,
      params?: ApiCallParams<VehicleUpdateVm>
    ) {
      if (params !== undefined) {
        const result = await putVehicleApi(params);

        if (result) {
          await ctx.dispatch(accountActions.GET_MY_ACCOUNT_DETAILS);
        }

        ctx.commit("updateIsUpdateMyVehicleButtonLoadingMutation", false);
      }
    }
  },
  mutations: {
    updateVehicleDataMutation(state?: any, vehicle?: VehicleVm) {
      state.vehicle = vehicle;
    },
    updateVehicleNameMutation(state?: any, vehicleName?: string) {
      state.vehicle.name = vehicleName;
    },
    updateVehicleDealerPhoneMutation(state?: any, vehicleDealerPhone?: string) {
      state.vehicle.dealerPhone = vehicleDealerPhone;
    },
    updateVehicleRegistrationNumberMutation(
      state?: any,
      vehicleRegistrationNumber?: string
    ) {
      state.vehicle.registrationNumber = vehicleRegistrationNumber;
    },
    updateVehicleBDownPhoneMutation(state?: any, vehicleBDownPhone?: string) {
      state.vehicle.bDownPhone = vehicleBDownPhone;
    },
    updateVehicleOilTypeMutation(state?: any, vehicleOilType?: string) {
      state.vehicle.oilType = vehicleOilType;
    },
    updateVehicleTyrePressureFMutation(
      state?: any,
      vehicleTyrePressureF?: string
    ) {
      state.vehicle.tyrePressureF = vehicleTyrePressureF;
    },
    updateVehicleTyrePressureRMutation(
      state?: any,
      vehicleTyrePressureR?: string
    ) {
      state.vehicle.tyrePressureR = vehicleTyrePressureR;
    },
    updateVehicleNoteMutation(state?: any, vehicleNote?: string) {
      state.vehicle.note = vehicleNote;
    }
  },
  state: {
    vehicle: {} as VehicleVm
  }
};
